import { Col, Container, Row } from "react-bootstrap";
import { Calendar, momentLocalizer } from "react-big-calendar";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { getEvents } from "./model/fetch";
import { Event } from "react-big-calendar";
import "./Calendar.css";

export function HKCalendar() {
  const [events, setEvents] = useState<Event[]>([]);
  const { width } = useWindowDimensions();

  const localizer = momentLocalizer(moment);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
  }

  useEffect(() => {
    getEvents((eventsList) => {
      setEvents(eventsList);
    });
  }, []);

  return (
    <Container>
      <div className="calendar mt-1">
        <Row>
          <Col lg={12} md={12}>
            <div>
              <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                defaultView={width < 720 ? "agenda" : "month"}
              />
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
